(function () {
  "use strict";

  var urunOnbellegi = Object.create(null);

  function karistir(liste) {
    for (var i = liste.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var gecici = liste[i];
      liste[i] = liste[j];
      liste[j] = gecici;
    }
    return liste;
  }

  function boyutluGorsel(adres, genislik) {
    try {
      var url = new URL(adres, window.location.origin);
      url.searchParams.set("width", String(genislik));
      return url.toString();
    } catch (hata) {
      return adres;
    }
  }

  function urunleriGetir(handle) {
    if (!urunOnbellegi[handle]) {
      urunOnbellegi[handle] = fetch(
        "/collections/" + encodeURIComponent(handle) + "/products.json?limit=250",
        { credentials: "same-origin" }
      )
        .then(function (yanit) {
          if (!yanit.ok) throw new Error("Koleksiyon ürünleri alınamadı");
          return yanit.json();
        })
        .then(function (veri) { return veri.products || []; });
    }
    return urunOnbellegi[handle];
  }

  function kartOlustur(ornek, urun, onEk) {
    var kart = ornek.cloneNode(true);
    var baglanti = kart.querySelector("a");
    var gorsel = kart.querySelector("img");
    var ad = kart.querySelector("." + onEk + "-urun-ad");
    var anaGorsel = urun.images && urun.images[0] && urun.images[0].src;

    if (baglanti) baglanti.href = "/products/" + encodeURIComponent(urun.handle);
    if (ad) ad.textContent = urun.title;
    if (gorsel && anaGorsel) {
      gorsel.src = boyutluGorsel(anaGorsel, 400);
      gorsel.srcset = [300, 400, 600].map(function (en) {
        return boyutluGorsel(anaGorsel, en) + " " + en + "w";
      }).join(", ");
      gorsel.alt = urun.title;
    }
    return kart;
  }

  function vitriniKaristir(liste) {
    if (liste.dataset.randomized === "true" || liste.dataset.randomStatic === "true") return;
    liste.dataset.randomized = "true";

    var handle = liste.dataset.collectionHandle;
    var onEk = liste.dataset.cardPrefix;
    var ornek = liste.querySelector("li");
    if (!handle || !onEk || !ornek) return;

    urunleriGetir(handle).then(function (urunler) {
      var gorselliler = urunler.filter(function (urun) {
        return urun.images && urun.images.length;
      });
      var havuz = gorselliler.length >= 6 ? gorselliler : urunler;
      var secilenler = karistir(havuz.slice()).slice(0, 6);
      if (!secilenler.length) return;

      var parca = document.createDocumentFragment();
      secilenler.forEach(function (urun) {
        parca.appendChild(kartOlustur(ornek, urun, onEk));
      });
      liste.replaceChildren(parca);
    }).catch(function () {
      // Ağ sorunu olursa Liquid ile gelen ilk altı kart kullanılmaya devam eder.
    });
  }

  function baslat(kok) {
    (kok || document).querySelectorAll("[data-random-preview]").forEach(vitriniKaristir);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { baslat(document); }, { once: true });
  } else {
    baslat(document);
  }
  document.addEventListener("shopify:section:load", function (olay) { baslat(olay.target); });
})();
